define('app/models/address',['app/setup'], function(takhfifan) {
  takhfifan.Address = Backbone.Model.extend({

      validation: {
        'postcode': {
          required: true,
          msg: i18n.t('postcode_missing')
        },
        'city': {
          required: true,
          msg: i18n.t('city_missing')
        },
        'region_id': {
          required: true,
          msg: i18n.t('region_missing')
        },

        'telephone': {
          required: true,
          msg: i18n.t('telephone_missing')
        },
        'street[0]': {
          required: true,
          msg: i18n.t('street_missing')
        }
      },

    destroy: function(id) {
      var url = '/customer/address/destroy/';
      var path = url + id;

      $.ajax({
        url: path,
        type: 'POST',
        data: { form_key: this.get('form_key') },
        dataType: 'json',
        success:function(data) {
          takhfifan.eventHub.trigger('address:removed', { id: id });
        },
        error: function(data, a, b){
          takhfifan.eventHub.trigger('address:removed-error', { id: id });
        }});
    },

    save: function(url) {
      var _this = this;
      var json = this.toJSON();

      // remove attributes that are for JS app only
      delete json.isActive;
      delete json.regionName;
      delete json.availableRegionCodes;

      $.post(url, json).done(function(data){
        if (!_.isNull(data)) {
          if (typeof data == 'string') {
            data = JSON.parse(data);
          }
          if (!_.isNull(data.error) && data.error == 1) {
            takhfifan.eventHub.trigger('address:error', [data.message]);
          }
          else {
            takhfifan.eventHub.trigger('address:saved', data.address);
          }
          if(!_.isNull(data.form_key))
          {
            takhfifan.eventHub.trigger('formkey', data.form_key);
          }
        }
      }).fail(function(data){
        takhfifan.eventHub.trigger(
          'address:error', [i18n.t('connection_error')]
        );
      });
    },

    clearFormData: function() {
      this.unset('shipping_address_id', {silent: true});
      this.set({
        'name': null,
        'address': null,
        'postcode': null,
        'city': null,
        'phone': null,
        'region_id': null
      });
    },

    loadFormData: function(data) {
      this.set({
        'address_id': data.addressId,
        'fullname': data.name,
        'address': data.street,
        'postcode': data.postcode,
        'city': data.city,
        'phone': data.phone,
        'region_id': data.regionId
      });
    }

  });

});

